// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__2UhZr","card":"Cards_card__1vLpx","infected":"Cards_infected__3VZh-","recovered":"Cards_recovered__1kr5H","deaths":"Cards_deaths__1JE2g"};